import { connect } from 'react-redux';

import UserBehavior from './UserBehavior.js';
import { redux as apiRedux } from '../api';
const { setPrevPage, setUserBehaviorTable } = apiRedux.actions;

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPrevPage: data => dispatch(setPrevPage(data)),
    setUserBehaviorTable: data => dispatch(setUserBehaviorTable(data)),
  };
};

const ConnectedUserBehavior = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserBehavior);

export default ConnectedUserBehavior;
